import { call, put, takeLatest } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import dashboardService from '@/services/dashboard/dashboardService';
import {
    fetchDashboardDataRequest,
    fetchDashboardDataSuccess,
    fetchDashboardDataFailure,
} from '../slices/dashboardSlice';
import { convertToDashboardData } from '@/features/student/StudentDashboard/helpers';

// Worker Sagas
function* fetchDashboardDataWorker(): SagaIterator {
    try {
        const data = yield call(dashboardService.getDashboardData);
        yield put(fetchDashboardDataSuccess(convertToDashboardData(data)));
    } catch (error: any) {
        yield put(fetchDashboardDataFailure(error.response?.data?.message || 'Failed to fetch dashboard data'));
    }
}

// Watcher Sagas
function* watchDashboard(): SagaIterator {
    yield takeLatest(fetchDashboardDataRequest.type, fetchDashboardDataWorker);
}

export default watchDashboard;
